import PropTypes from 'prop-types';
import React from 'react';
import getData from './getData';

/**
 *  Describe the component
 *
 */
function Listing(_ref) {
  let {
    baseUrl,
    inventory,
    schemaTemplate = {},
    schemaType = 'Car',
    searchLocation,
    ...rest
  } = _ref;
  return /*#__PURE__*/React.createElement("script", Object.assign({
    "data-cmp": "lstgSchema",
    type: "application/ld+json"
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: `${JSON.stringify(getData(inventory, searchLocation, schemaTemplate, baseUrl, schemaType))}`
    }
  }, rest));
}
export default Listing;